<div class="slider-container">
  <label class="slider-label">{{ label }}</label>

  <div class="slider-inputs input-group">
    <div class="slider-input-wrap">
      <mat-form-field appearance="outline" class="slider-field">
        <input
          matInput
          type="number"
          [value]="rangeStart"
          [min]="min"
          [max]="max"
          [step]="step"
          (input)="onRangeStartInput($any($event.target).value)"
          (blur)="validateAndEmit()"
        />
      </mat-form-field>
      <div class="stepper-rail">
        <button type="button" class="stepper-btn" (click)="changeRangeStart(step)">+</button>
        <button type="button" class="stepper-btn" (click)="changeRangeStart(-step)">-</button>
      </div>
    </div>

    <div class="slider-input-wrap">
      <mat-form-field appearance="outline" class="slider-field">
        <input
          matInput
          type="number"
          [value]="rangeEnd"
          [min]="min"
          [max]="max"
          [step]="step"
          (input)="onRangeEndInput($any($event.target).value)"
          (blur)="validateAndEmit()"
        />
        <mat-error *ngIf="errorMsg">{{ errorMsg }}</mat-error>
      </mat-form-field>
      <div class="stepper-rail">
        <button type="button" class="stepper-btn" (click)="changeRangeEnd(step)">+</button>
        <button type="button" class="stepper-btn" (click)="changeRangeEnd(-step)">-</button>
      </div>
    </div>
    
  </div>

  <mat-slider
    [min]="min"
    [max]="max"
    [step]="step"
    (change)="onRangeChange()"
  >
    <input matSliderStartThumb [(ngModel)]="rangeStart" />
    <input matSliderEndThumb [(ngModel)]="rangeEnd" />
  </mat-slider>
</div>
